const image = (url, alt) => {
  if (url) {
    return <img src={url} alt={alt} />;
  }

  return undefined;
};

const setInnerHTML = (content) => {
  return { __html: content };
};

const Podcast = ({ url, title, imageUrl, description, language }) => {
  return (
    <div className="cast">
      <h3>
        <a href={url} title={title} target="_blank" rel="noreferrer">
          {title}
        </a>
      </h3>
      {image(imageUrl, title)}

      <p
        className="descCast inCast"
        dangerouslySetInnerHTML={setInnerHTML(description)}
      />
      <div className="footCast inCast">
        <p>
          <strong>
            Go to{" "}
            <a
              href={url}
              title={title + "'s site"}
              target="_blank"
              rel="noreferrer"
            >
              the podcast's website
            </a>
          </strong>
        </p>
        <h5>Language: {language || "🇬🇧"}</h5>
      </div>
    </div>
  );
};

export default Podcast;
